module.exports = __webpack_public_path__ + "sim2.4ade4993.png";